import { FC, JSX } from "react";
import { Linking, Text } from "react-native";
import { IGetInsurancePolicyResponse } from "@/_store/insurancePolicy/contracts";
import List, { ListItems } from "@/app/components/List";
import Divider from "@/app/components/Divider";
import CustomButton from "@/app/components/CustomButton";
import useHandleDownload from "@/_hooks/Download/useHandleDownload";
import { formatInsuranceAmount } from "@/_utils/formatAmount";
import { DATE_FORMAT } from "@/_utils/formatDate";
import dayjs from "dayjs";
import Skeleton from "@/app/components/Skeleton";
import { EdgeInsets, useSafeAreaInsets } from "react-native-safe-area-context";
import Container from "@/app/components/Container";

interface IPolicyProps {
  policyData: IGetInsurancePolicyResponse | undefined;
  isLoading: boolean;
}

const Policy: FC<IPolicyProps> = ({ policyData, isLoading }): JSX.Element => {
  const handleDownload = useHandleDownload();

  const {
    number,
    period,
    policy_url,
    company_name,
    insurance_date,
    insurance_deal,
    contact_mobile_phone,
  } = policyData ?? {}

  const policyInfoItems: ListItems[] = [
    { label: "Дата страхования", value: dayjs(insurance_date).format(DATE_FORMAT) },
    { label: "Срок действия", value: dayjs(period).format(DATE_FORMAT) },
    { label: "Страхователь", value: company_name },
    { label: "Размер страхового покрытия", value: formatInsuranceAmount(insurance_deal ?? 0) },
    { label: "Контакты для страховых случаев", value: contact_mobile_phone },
  ];

  const openFileLink = (): Promise<void> => Linking.openURL(policy_url ?? "");
  const insets: EdgeInsets = useSafeAreaInsets();

  const handleDownloadPolicy = (): void => {
    handleDownload({
      url: policy_url,
      errorMessage: "При скачивании полиса произошла ошибка",
      filename: "Полис.pdf"
    });
  };

  const renderPolicyNumberOrSkeleton = (): JSX.Element => !isLoading
    ? <>{number ?? "Информация отсутствует"}</>
    : <Skeleton />;

  return (
    <Container style={{ paddingBottom: insets.bottom + 150 }} className="flex-1 p-5">
      <Text className="flex flex-row text-header">
        <Text className="min-w-28">Полис №</Text>
        {renderPolicyNumberOrSkeleton()}
      </Text>
      <List items={policyInfoItems} />
      <Divider />
      <CustomButton
        className="mb-6"
        title="Показать полис"
        onPress={openFileLink}
      />
      <CustomButton
        type="default"
        title="Скачать полис"
        onPress={handleDownloadPolicy}
      />
    </Container>
  );
};

export default Policy;
